// Next Imports
import Link from 'next/link'

// Component Imports
import ModeToggle from '@/components/layout/ModeToggle'

// Config Imports
import { siteConfig } from '@/configs/site-config'

// Asset Imports
import Logo from '@/assets/svg/logo'

const AuthTopBar = () => {
  return (
    <header className='relative z-10 flex items-center justify-between gap-4 px-6 py-4 sm:px-8'>
      <Link
        href='/'
        aria-label='Back to the app'
        className='focus-visible:ring-ring/50 flex items-center gap-2.5 rounded-lg outline-none focus-visible:ring-3'
      >
        <Logo className='size-8 rounded-md' />
        <span className='text-base font-semibold tracking-tight'>{siteConfig.name}</span>
      </Link>

      <ModeToggle />
    </header>
  )
}

export default AuthTopBar
